/* Co-Art Studio hero: reduced-motion aware background video.

   The <video> carries no autoplay attribute, so nothing plays until this
   decides to. A paused <video> paints its poster, which is exactly the
   reduced-motion presentation the design asks for. */

class CoartHero extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('.coart-hero__video');
    if (!this.video) return;

    this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.apply = this.apply.bind(this);

    this.apply();
    this.motionQuery.addEventListener('change', this.apply);
  }

  disconnectedCallback() {
    this.motionQuery?.removeEventListener('change', this.apply);
  }

  apply() {
    if (this.motionQuery.matches) {
      this.video.pause();
      // Back to frame zero so the poster, not a stalled frame, is what shows.
      this.video.currentTime = 0;
      this.video.removeAttribute('loop');
      return;
    }

    this.video.setAttribute('loop', '');
    // Muted playback is normally allowed, but a browser may still refuse;
    // the poster stays up in that case, which is an acceptable resting state.
    this.video.play().catch(() => {});
  }
}

if (!customElements.get('coart-hero')) {
  customElements.define('coart-hero', CoartHero);
}
